export default __webpack_public_path__ + "static/home_main-2789d3777a5387828816b655b6fa144e.png";